import { Routes } from '@angular/router';
import { AuthGuard } from '@infra/guards/auth/auth.guard';
import { LoginGuard } from '@infra/guards/login/login.guard';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [LoginGuard],
    loadComponent: () =>
      import('./presentation/pages/login/login.component').then(
        m => m.LoginComponent
      )
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'fornec-xml-rel-acompanhamento'
  },
  {
    path: 'fornec-xml-rel-acompanhamento',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('@presentation/pages/captacao-nfe/captacao-nfe.component').then(
        m => m.CaptacaoNfeComponent
      )
  },
  {
    path: '**',
    redirectTo: 'fornec-xml-rel-acompanhamento'
  }
];
